import React from "react";
import ConfirmationModal from "app/components/common/ConfirmationModal";
import "./DeleteConfirmationModal.css";

export const deleteJobLabel = (loading) =>
  loading ? "Deleting..." : "Delete Job";

const DeleteConfirmationModal = ({
  show,
  onHide,
  onConfirm,
  loading = false,
  confirmDisabled = false,
  banner = null,
  note = null,
  footer = null,
}) => (
  <ConfirmationModal
    show={show}
    onHide={onHide}
    onConfirm={onConfirm}
    title="Delete Job?"
    confirmLabel="Delete Job"
    loadingLabel="Deleting..."
    isLoading={loading}
    confirmDisabled={confirmDisabled}
    footer={footer}
    staticWhileLoading
  >
    {banner}
    <p className="delete-modal-copy">
      <span className="d-block">
        All job data will be permanently removed, including the booking,
        inspection results, and any compiled report.
      </span>
      <span className="d-block">This action cannot be undone.</span>
    </p>
    {note}
  </ConfirmationModal>
);

export default DeleteConfirmationModal;
